import { Form, FormContext, Flex, SelectPrice, IPriceRange } from 'dash-ui';
import { useCallback, useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { FormFields } from 'containers/properties/PropertyGeneralInformation/components/PropertyGeneralInfoForm/constants/constants';
import useValidation from 'containers/properties/PropertyGeneralInformation/components/PropertyGeneralInfoForm/hooks/useValidation';

const PriceRangeInput = () => {
  const { t } = useTranslation(['forms', 'common', 'pages']);
  const { formErrors, stateHandlers, formState, errorHandlers } =
    useContext(FormContext);
  const valid = useValidation();

  const onChange = useCallback(
    (value: IPriceRange) => {
      stateHandlers[FormFields.Prices](value);
      valid(FormFields.Prices, value);
    },
    [stateHandlers, valid]
  );

  return (
    <Flex flexDirection="column" mr={2} flex={1}>
      <Form.Label>{t('forms:labels.priceOfProperty')}</Form.Label>
      <SelectPrice
        menuPortalZIndex="auto"
        w="100%"
        defaultValue={formState.prices}
        hasInput
        disablePriceMask
        disableRangeDropdown
        placeholder={
          t('forms:placeholders.priceRange') || '$1,000,000 - $2,000,000'
        }
        onChange={onChange}
        onClear={() => {
          errorHandlers[FormFields.Prices](null);
        }}
        $errorType={formErrors[FormFields.Prices]?.type}
      />
      <div onFocus={(e) => e.preventDefault()}>
        <Form.Feedback $errorType={formErrors[FormFields.Prices]?.type}>
          {formErrors[FormFields.Prices]?.message}
        </Form.Feedback>
      </div>
    </Flex>
  );
};

export default PriceRangeInput;
